import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from '../../../Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from '../../Core';
import ids from '../../QestIds';
import MeasurementsAndObservationsSection from './Sections/MeasurementsAndObservationsSection';
import PreparationSection from './Sections/PreparationSection';
import ResultsSection from './Sections/ResultsSection';

const qestIds = [ids.emersonClassification.AS_1289_3_8_1.rev2017];

let AsEmersonClassificationWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <PageSection heading="Test Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Measurements and Observations">
        <MeasurementsAndObservationsSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <NamePrefixModifier appendNamePrefix="Results">
          <ResultsSection />
        </NamePrefixModifier>
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsEmersonClassificationWorksheet = withInjectedProps(AsEmersonClassificationWorksheet);
AsEmersonClassificationWorksheet.qestIds = qestIds;

export default AsEmersonClassificationWorksheet;
export { AsEmersonClassificationWorksheet };
